import React from 'react';
import CheckoutPageTimer from './CheckoutPageTimer';
import SpotMap from './../../containers/SpotMap';

const CheckoutPageHeader = ({event, pendingTime, spotToUnreserve, spotToReserve, isInValidTimer}) => {
  const spotId = spotToReserve || spotToUnreserve;
  const isSpotValid = !!spotId;
  return (
    <div className="map-page-content-head clearfix">
      {event === 'hold' && <CheckoutPageTimer pendingTime={pendingTime} isInValidTimer={isInValidTimer} /> }
      {isSpotValid && <SpotMap spotId={spotId} /> }
    </div>
  );

};

export default CheckoutPageHeader;



// WEBPACK FOOTER //
// ./src/components/checkout/CheckoutPageHeader.js